/* eslint-disable */
// 登录记录
import AdminLoginRecord from './login-record/reducer/LoginRecord.js';
export default {
  AdminLoginRecord,
};
